import { __decorate } from "tslib";
import { AccessibilityFrontendSharedModule } from '@common/accessibility/frontend-shared';
import { provideFeatureAddonRoutes, provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let AccessibilityFrontendFeature = /*#__PURE__*/(() => {
  let AccessibilityFrontendFeature = class AccessibilityFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/accessibility/frontend","featureId":"common-accessibility"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        profile: [{
          label: 'Darstellung & Barrierefreiheit',
          routerLink: './accessibility-settings',
          priority: 5
        }],
        toolbar: [{
          displayInGroup: 'toolbar/more',
          onMissingGroup: 'remove',
          label: 'Darstellung & Barrierefreiheit',
          routerLink: '/accessibility-settings',
          icon: 'eye',
          priority: 5
        }],
        adminTopMenu: [{
          label: 'Darstellung & Barrierefreiheit',
          routerLink: '/accessibility-settings',
          icon: 'eye',
          priority: 5
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵAccessibilityFrontendFeature_BaseFactory;
        return function AccessibilityFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵAccessibilityFrontendFeature_BaseFactory || (ɵAccessibilityFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(AccessibilityFrontendFeature)))(__ngFactoryType__ || AccessibilityFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: AccessibilityFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'accessibility-settings',
          loadComponent: () => import('@common/accessibility/frontend-shared/components/wrapper.component').then(m => m.AccessibilitySettingsWrapperComponent)
        }]), provideFeatureAddonRoutes([{
          useAddonSlot: 'user/profile',
          path: 'accessibility-settings',
          loadComponent: () => import('@common/accessibility/frontend-shared/components/accessibility-settings.component').then(m => m.AccessibilitySettingsComponent)
        }])],
        imports: [AccessibilityFrontendSharedModule]
      });
    }
  };
  AccessibilityFrontendFeature = __decorate([ClassName("AccessibilityFrontendFeature")], AccessibilityFrontendFeature);
  return AccessibilityFrontendFeature;
})();
export { AccessibilityFrontendFeature };